import { Alert, Box, Grid } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Flex from "@/components/Flex";
import OutlineCard from "@/components/OutlineCard";
import { NAVBAR_HEIGHT_PLUS15 } from "@/components/app/nav-bar/NavBar";
import StyledButtonV2 from "@/components/app/StyledButtonV2";
import { CATALOG_IMPORT_NOTICE_ACTION_LABEL } from "@/pages/app/admin/library/catalog/catalog-constant";
import { usePendingCatalogImports } from "@/pages/app/admin/library/catalog/hooks/use-pending-catalog-imports";
import { PROVIDER_PATHS } from "@/constants/paths";
import {
  COSIGN_PIN_NOTICE,
  COSIGN_PIN_NOTICE_ACTION_LABEL,
} from "./constant/dashboard-constant";
import { useCosignPinRequired } from "./hooks/use-cosign-pin-required";
import DashBoardAppointmentStatusSection from "./sections/DashBoardAppointmentStatusSection";
import {
  DashBoardTodaysTask,
  DashboardQuestionnaireReviewSection,
} from "./sections/dashboard-bottom-left-section/BottomScheduleSection";
import DashboardCalender from "./sections/dashboard-calender/DashboardCalender";
import { DashMessagesBox } from "./sections/dashboard-right-section/DashMessagesBox";

const DASHBOARD_CARD_HEIGHT = `calc(100vh - ${NAVBAR_HEIGHT_PLUS15})`;

const Dashboard = () => {
  const navigate = useNavigate();
  const { pendingTabs, notice } = usePendingCatalogImports();
  const isCosignPinRequired = useCosignPinRequired();

  return (
    <Box margin={1.5}>
      <Grid container spacing={1}>
        {/* Left Main Content */}
        <Grid
          item
          xs={12}
          md={8.5}
          sx={{
            display: "flex",
            flexDirection: "column",
            height: DASHBOARD_CARD_HEIGHT,
            minHeight: 500,
          }}
        >
          {pendingTabs.length > 0 && (
            <Alert
              severity="warning"
              role="status"
              action={
                <StyledButtonV2
                  label={CATALOG_IMPORT_NOTICE_ACTION_LABEL}
                  onClick={() => navigate(pendingTabs[0].providerPath)}
                  variant="outlined"
                  sx={{ whiteSpace: "nowrap" }}
                />
              }
              sx={{ mb: 1, alignItems: "center" }}
            >
              {notice}
            </Alert>
          )}
          {isCosignPinRequired && (
            <Alert
              severity="warning"
              role="status"
              action={
                <StyledButtonV2
                  label={COSIGN_PIN_NOTICE_ACTION_LABEL}
                  onClick={() => navigate(PROVIDER_PATHS.ACCOUNT_SETTINGS)}
                  variant="outlined"
                  sx={{ whiteSpace: "nowrap" }}
                />
              }
              sx={{ mb: 1, alignItems: "center" }}
            >
              {COSIGN_PIN_NOTICE}
            </Alert>
          )}

          {/* Active Cases Status Section */}
          <Box mb={1}>
            <DashBoardAppointmentStatusSection />
          </Box>

          {/* Questionnaire Review + Today's Appointments side by side */}
          <Flex flex={1} gap={1} overflow="hidden">
            <Flex flex={1} flexDirection="column" minWidth={0}>
              <OutlineCard
                sx={{
                  borderRadius: 2,
                  flex: 1,
                  display: "flex",
                  flexDirection: "column",
                  overflow: "hidden",
                }}
              >
                <DashboardQuestionnaireReviewSection />
              </OutlineCard>
            </Flex>

            <Flex flex={1} flexDirection="column" minWidth={0}>
              <OutlineCard
                sx={{
                  borderRadius: 2,
                  flex: 1,
                  display: "flex",
                  flexDirection: "column",
                  overflow: "hidden",
                }}
              >
                {/* <DashBoardTodaysAppointment /> */}
                <DashboardCalender />
              </OutlineCard>
            </Flex>
          </Flex>
        </Grid>

        {/* Right Sidebar: Today's Tasks + Messages */}
        <Grid
          item
          xs={12}
          md={3.5}
          sx={{
            display: "flex",
            flexDirection: "column",
            height: DASHBOARD_CARD_HEIGHT,
            minHeight: 500,
            paddingLeft: "8px",
          }}
        >
          {/* Today's Tasks */}
          <OutlineCard
            sx={{
              borderRadius: 2,
              flex: 1,
              display: "flex",
              flexDirection: "column",
              overflow: "hidden",
              mb: 1,
            }}
          >
            <DashBoardTodaysTask />
          </OutlineCard>

          {/* Messages / Activity */}
          <OutlineCard
            sx={{
              borderRadius: 2,
              bgcolor: "#fff",
              flex: 1,
              display: "flex",
              flexDirection: "column",
              overflow: "hidden",
            }}
          >
            <DashMessagesBox />
          </OutlineCard>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Dashboard;
